import { Card } from "@src/appV2/redesign/system/ui-components";

interface ChartingCardWrapperProps {
  children: React.ReactNode;
  image: string;
  background?: string;
}

export function ChartingCardWrapper(props: ChartingCardWrapperProps) {
  const { children, image, background } = props;
  const imageSize = 170;
  const transform = "rotate(-10deg)";
  return (
    <Card
      sx={{
        padding: 6,
        minHeight: "fit-content",
        background,
        position: "relative",
        overflow: "hidden",
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: -20,
          right: -20,
          width: imageSize,
          height: imageSize,
          background: `url(${image})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          transform,
          transformOrigin: "center",
          pointerEvents: "none",
        },
      }}
      variant="tertiary"
    >
      {children}
    </Card>
  );
}
